import axios from 'axios';

const API_BASE = '/api/sales-leads';

export const salesLeadService = {
  getAll: async (params = {}) => {
    const response = await axios.get(API_BASE, { params });
    return response.data;
  },
  getById: async (id) => {
    const response = await axios.get(`${API_BASE}/${id}`);
    return response.data;
  },
  create: async (data) => {
    const response = await axios.post(API_BASE, data);
    return response.data;
  },
  update: async (id, data) => {
    const response = await axios.put(`${API_BASE}/${id}`, data);
    return response.data;
  },
};
